<div class="p-3 h-full">
  <mat-card class="h-full">
    <mat-card-header>
      <mat-card-title>{{ 'personal_content.routes.coop_default' | transloco }}</mat-card-title>
    </mat-card-header>

    <pc-message-list-container class="h-full"></pc-message-list-container>
  </mat-card>
</div>
